export default __webpack_public_path__ + "static/media/fav-orange.26cde693.png";